export enum InventoryLoaderKey {
  LIST_ITEMS = 'inventory-list',
  LIST_BATCHES = 'inventory-batches',
  LIST_METRICS = 'inventory-metrics',
}
